`include "{{ bfmBase.packageFilePath }}"
{{#each bfms}}
`include "{{ packageFilePath }}"
{{#each deepSubclasses}}
`include "{{ packageFilePath }}"
{{/each}}
{{/each}}

`include "{{ bfmCreator.packageFilePath }}"
